import { on_ready, is_elementor_edit } from 'js/utils';
import { init_retina } from 'js/retina';
import { init_toggle_height } from 'js/toggle_height_init';

import { init_header } from 'modules/header/header';
import init_forms from 'modules/forms/forms';
import init_carousels from 'modules/carousel/carousel';
import init_footer from 'modules/footer/footer';
import init_nav_menu from 'modules/menu/nav/nav';

// load global styles
import './main.scss';

// if( import.meta.hot ) {
//     import.meta.hot.accept(); 
// }

on_ready(()=>{

    init_footer();

    if( is_elementor_edit() ) return;
    
    // forms ui + gravityforms customizations
    // move outside of tasks queue, have issues with hooks registered late
    init_forms();

    init_header();

    init_nav_menu();

    init_carousels(); // swiper

    init_retina(); // @images

    init_toggle_height(); // toggle element height from 0 to default - for animating height

    // on_mobile();

    type_out_heading();
    
    init_dynamic_load();

    init_load_more_locations();
    
    document.dispatchEvent(new Event('after_main_init'));
});

// function on_mobile(){
//     if( window.innerWidth > 768 ) return;
// }

function init_dynamic_load(){

    // search popup: remove if not used
    if( document.querySelector('.search_popup_open') ) {
        import('modules/search/search_popup/init');
    }
    
    // burger / mobile menu: remove if not used
    if( document.querySelector('.slide_menu_open') ) {
        import('modules/menu/slide_menu/init');
    }

    // wishlist & compare: remove if not used
    if( document.querySelector('.compare_count') ||
        document.querySelector('.wishlist_count') ) {
        import('modules/save_items/init');
    }
    
    // cookie consent
    // if( !get_cookie('ff_cookie_consent') ) {
    //     import('modules/cookie_consent/simple/simple')
    // }
}

function type_out_heading() {
    const headings = document.querySelectorAll('.type-out .elementor-heading-title');
    if (!headings.length) return;

    // Use observer to trigger type-out only when visible
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const heading = entry.target;

                // Prevent re-triggering
                if (heading.dataset.typeoutDone) return;
                heading.dataset.typeoutDone = "1";

                const span = heading.querySelector('span');
                const spanHTML = span ? span.outerHTML : "";
                const rawText = heading.textContent.trim().replace('.', '');

                heading.innerHTML = ''; // clear text
                let i = 0;

                const type = () => {
                    if (i < rawText.length) {
                        heading.innerHTML = rawText.substring(0, i + 1);
                        i++;
                        setTimeout(type, 50);
                    } else {
                        heading.innerHTML += spanHTML;
                    }
                };

                type();

                observer.unobserve(heading);
            }
        });
    }, {
        threshold: 0.3 // 30% visible triggers
    });

    // Observe each heading
    headings.forEach(h => observer.observe(h));
}

function closed_accordion_mobile() {
    const is_mobile = window.innerWidth < 768;
    
    if (!is_mobile) return;

    const delay = 100;
    setTimeout(() => {
        jQuery('.e-n-accordion-item').removeAttr('open');
    }, delay);
}
window.addEventListener('load', closed_accordion_mobile);
window.addEventListener('resize', closed_accordion_mobile);


function init_load_more_locations() {
    document.addEventListener('click', (e) => {
        const button = e.target.closest('.load-more-locations');
        if (!button) return;

        const wrapper = button.closest('.location-overview');
        const inner = wrapper.querySelector('.inner');
        const showposts = parseInt(wrapper.dataset.showposts, 10);
        const hiddenItems = inner.querySelectorAll('.location-item:not(.active)');

        if (!hiddenItems.length) {
            button.remove();
            return;
        }

        const revealCount = showposts;
        let revealed = 0;
        hiddenItems.forEach((item, i) => {
            if (revealed < revealCount) {
                item.classList.add('active');
                item.style.animationDelay = `${i * 0.1}s`;
                revealed++;
            }
        });

        // Remove button if all are active
        if (inner.querySelectorAll('.location-item:not(.active)').length === 0) {
            button.remove();
        }
    });
}